import r from'@mui/material/Avatar';var a=r;export{a as Avatar};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map